import Contact from './components/Contact';

export default function Header() {
	return (
		<header>
			<p>
				Hi. I'm Joanna Kus.
				<br />
				I'm a software engineer with three years of backend and
				scripting experience. I'm working on stepping into a more
				security-focused role. I wrote this site myself from scratch in
				React. This website is still in progress. Check back later; I
				promise it'll be cool.
			</p>
			<Contact />
		</header>
	);
}
